const credentials = [
  'GOV.UK & GDS aligned delivery standards',
  'WCAG 2.1 AA accessibility',
  'PRINCE2 & Agile / Scrum delivery',
  'Drupal & LocalGov Drupal',
];

export default function Hero() {
  return (
    <div className="app-hero">
      <div className="govuk-width-container">
        <div className="govuk-grid-row govuk-!-padding-top-6 govuk-!-padding-bottom-6">
          <div className="govuk-grid-column-two-thirds">
            <span className="govuk-caption-xl">IT Project Manager · Public Sector Digital Transformation</span>
            <h1 className="govuk-heading-xl govuk-!-margin-bottom-3">Harsh Trivedi</h1>
            <p className="govuk-body-l">
              Computer Science graduate and IT Project Manager with hands-on software
              engineering experience delivering digital transformation across public
              services. As a former Technical Specialist at Leicestershire County Council,
              I led statutory service digitisation, accessible platform delivery and
              AI-powered citizen services - pairing PRINCE2-governed project leadership
              with the technical depth to design and build the solutions myself. Based
              in Coventry, UK.
            </p>
            <div className="govuk-button-group">
              <a
                href="#experience"
                role="button"
                draggable="false"
                className="govuk-button govuk-button--start"
                data-module="govuk-button"
              >
                View my experience
                <svg
                  className="govuk-button__start-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.5"
                  height="19"
                  viewBox="0 0 33 40"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
                </svg>
              </a>
              <a href="#contact" className="govuk-link govuk-!-margin-left-2">
                Get in touch
              </a>
            </div>
          </div>

          <div className="govuk-grid-column-one-third">
            <div className="govuk-!-padding-4" style={{ background: '#ffffff', border: '1px solid #b1b4b6' }}>
              <h2 className="govuk-heading-s govuk-!-margin-bottom-3">At a glance</h2>
              <ul className="govuk-list">
                {credentials.map((c) => (
                  <li key={c} className="govuk-!-margin-bottom-2">
                    <strong className="govuk-tag govuk-!-margin-right-1">&#10003;</strong>
                    {c}
                  </li>
                ))}
              </ul>
              <hr className="govuk-section-break govuk-section-break--visible govuk-section-break--m" />
              <p className="govuk-body govuk-!-margin-bottom-1">
                <span className="govuk-!-font-weight-bold govuk-!-font-size-36">50%</span> statutory SLA
                improvement delivered at Leicestershire County Council
              </p>
              <p className="govuk-body govuk-!-margin-bottom-0">
                <span className="govuk-!-font-weight-bold govuk-!-font-size-36">7</span> developers and
                testers line-managed
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
